var DealContentLoader, sendExperimentTrackyMessage;

window.Backbone = require('backbone');

window.Backbone.$ = window.$;

DealContentLoader = require('../../../../modules/deal/frontend/deal_content_loader');

DealContentLoader.init(false);

require('../../../../modules/tracking/frontend/initializer');

require('../../../../modules/buy_button/desktop_2016/frontend/buy_button');

require('../../../../modules/buy_button/desktop_2016/frontend/multi_option_modal');

require('../../../../modules/deal/frontend/channel_tabs');

require('../../../../modules/deal/frontend/controller');

require('../../../../modules/deal/frontend/external_links');

require('../../../../modules/gift_button/frontend/gift');

require('../../../../modules/g_map/frontend/main');

require('../../../../modules/external_deal/frontend/external_deal');

require('../../../../modules/sharing/frontend/facebook');

require('../../../../modules/deal/frontend/deal_lazy_loader');

require('../../../../modules/deal/frontend/deal_track_content_loaded');

require('../../../../modules/variations/frontend/variations-widget');

require('../../../../modules/doubleclick/frontend/dfp_ads');

require('../../../../modules/deal_widget/frontend/deal_widgets');

require('../../../../modules/deal_highlights/frontend/deal_highlights');

require('../../../../modules/ad_unit/frontend/ad_unit_lazy_loader');

require('../../../../modules/wishlist_button/frontend/wishlist');

require('../../../../modules/applepay/desktop2016/frontend/main');

require('../../../../modules/member_only/frontend/main');

require('../vendor_modules/fix-a11y');

require('groupon-iframe-login');

require('hogan.js');

require('../../../../modules/groupon-deal-carousel/frontend/swfobject-2.2');

require('../../../../modules/groupon-deal-carousel/frontend/detect-flash');

require('../../../../modules/groupon-deal-carousel/frontend/templates/main');

require('../../../../modules/groupon-deal-carousel/frontend/helpers');

require('../../../../modules/groupon-deal-carousel/frontend/models/media');

require('../../../../modules/groupon-deal-carousel/frontend/views/carousel');

require('../../../../modules/groupon-deal-carousel/frontend/carousel');

sendExperimentTrackyMessage = require('../../../../modules/experiments/frontend/sendExperimentTrackyMessage');

DealContentLoader.addOnLoadHandler(function() {
  var Groupon, ref, ref1, ref2;
  Groupon = window.Groupon;
  Groupon.Performance.pageReady();
  if ((ref = Groupon.DFPAds) != null) {
    if (typeof ref.load === "function") {
      ref.load();
    }
  }
  if ((ref1 = Groupon.DFPAds) != null) {
    if (typeof ref1.showAds === "function") {
      ref1.showAds();
    }
  }
  if ((ref2 = window.AdUnitLazyLoader) != null) {
    ref2.load();
  }
  return sendExperimentTrackyMessage();
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvYWtlc2hhcmkvbmFwaXN0cmFuby9idWlsZC8xNDk1NjYwODk4MjQ5LTQzOTYvcHJvZHVjdGlvbi0yMDE3LjA1LjI0XzIxLjE5L2RlYWwvY29yZS9mcm9udGVuZC9zY3JpcHRzL2Rlc2t0b3BfMjAxNi9kZXNrdG9wXzIwMTZfYmFzZS5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ha2VzaGFyaS9uYXBpc3RyYW5vL2J1aWxkLzE0OTU2NjA4OTgyNDktNDM5Ni9wcm9kdWN0aW9uLTIwMTcuMDUuMjRfMjEuMTkvZGVhbC9jb3JlL2Zyb250ZW5kL3NjcmlwdHMvZGVza3RvcF8yMDE2L2Rlc2t0b3BfMjAxNl9iYXNlLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBOztBQUFBLE1BQU0sQ0FBQyxRQUFQLEdBQWtCLE9BQUEsQ0FBUSxVQUFSOztBQUNsQixNQUFNLENBQUMsUUFBUSxDQUFDLENBQWhCLEdBQW9CLE1BQU0sQ0FBQzs7QUFHM0IsaUJBQUEsR0FDRSxPQUFBLENBQVEsdURBQVI7O0FBQ0YsaUJBQWlCLENBQUMsSUFBbEIsQ0FBdUIsS0FBdkI7O0FBRUEsT0FBQSxDQUFRLG1EQUFSOztBQUNBLE9BQUEsQ0FBUSxpRUFBUjs7QUFDQSxPQUFBLENBQVEseUVBQVI7O0FBQ0EsT0FBQSxDQUFRLGdEQUFSOztBQUNBLE9BQUEsQ0FBUSw4Q0FBUjs7QUFDQSxPQUFBLENBQVEsa0RBQVI7O0FBQ0EsT0FBQSxDQUFRLCtDQUFSOztBQUNBLE9BQUEsQ0FBUSx5Q0FBUjs7QUFDQSxPQUFBLENBQVEsMERBQVI7O0FBQ0EsT0FBQSxDQUFRLCtDQUFSOztBQUNBLE9BQUEsQ0FBUSxvREFBUjs7QUFDQSxPQUFBLENBQVEsNkRBQVI7O0FBQ0EsT0FBQSxDQUFRLDJEQUFSOztBQUNBLE9BQUEsQ0FBUSxrREFBUjs7QUFDQSxPQUFBLENBQVEsdURBQVI7O0FBQ0EsT0FBQSxDQUFRLDhEQUFSOztBQUNBLE9BQUEsQ0FBUSwwREFBUjs7QUFDQSxPQUFBLENBQVEsdURBQVI7O0FBQ0EsT0FBQSxDQUFRLHdEQUFSOztBQUNBLE9BQUEsQ0FBUSwrQ0FBUjs7QUFDQSxPQUFBLENBQVEsNEJBQVI7O0FBR0EsT0FBQSxDQUFRLHNCQUFSOztBQU9BLE9BQUEsQ0FBUSxVQUFSOztBQUNBLE9BQUEsQ0FBUSxrRUFBUjs7QUFDQSxPQUFBLENBQVEsaUVBQVI7O0FBQ0EsT0FBQSxDQUFRLG1FQUFSOztBQUNBLE9BQUEsQ0FBUSw0REFBUjs7QUFDQSxPQUFBLENBQVEsaUVBQVI7O0FBQ0EsT0FBQSxDQUFRLG1FQUFSOztBQUNBLE9BQUEsQ0FBUSw2REFBUjs7QUFHQSwyQkFBQSxHQUE4QixPQUFBLENBQVEsc0VBQVI7O0FBRTlCLGlCQUFpQixDQUFDLGdCQUFsQixDQUFtQyxTQUFBO0FBQ2pDLE1BQUE7RUFBQSxPQUFBLEdBQVUsTUFBTSxDQUFDO0VBQ2pCLE9BQU8sQ0FBQyxXQUFXLENBQUMsU0FBcEIsQ0FBQTs7O1NBQ2MsQ0FBRTs7Ozs7VUFDRixDQUFFOzs7O1FBQ08sQ0FBRSxJQUF6QixDQUFBOztTQUNBLDJCQUFBLENBQUE7QUFOaUMsQ0FBbkMifQ==
